import React, { useEffect, useState } from "react";
import NavLateral from "./navLateral";
import api from "../../../../services/api";
import { useNavigate, useParams } from "react-router-dom";
import RegisterAccess from "../../../../utils/registerAccess";
import AlertEdit from "../../../../utils/alertEdit";
import TextoFormatado from "../../../../utils/textoFormatado";
import { useSelector } from "react-redux";
import ProcessoLoading from "../../../../load/processoLoading";
import HeaderSession from "../../../../utils/headerSession";

export default function GestPedidosLicenciamento({ element: component, ...rest }) {
  const alert = useSelector(state => state.alert.data);
  const navigate = useNavigate();
  const { id } = useParams();
  const [estabelecimento, setEstabelecimento] = useState(null);
  const [solicitacaoRenovacao, setSolicitacaoRenovacao] = useState(null);
  const [observacoesFeitas, setObservacoesFeitas] = useState(null);

  useEffect(() => {
    setEstabelecimento(null);
    setObservacoesFeitas(null);

    api.get(`/estabelecimento/${id}`)
      .then(response => {
        const est = response.data.estabelecimento;
        if (est.approved === true && est.status === 'Activo') {
          navigate(`/admin/gestor-licenciados/${id}`);
          return;
        }
        setEstabelecimento(est);
        setSolicitacaoRenovacao(response.data?.solicitacaoRenovacaos ?? null);
      })
      .catch(() => {});

    api.get(`/observacaos?estabelecimentoId=${id}`)
      .then(response => setObservacoesFeitas(response.data.observacaos ?? []))
      .catch(() => setObservacoesFeitas([]));
  }, [id, alert]);

  return (
    <div className="tw-max-w-7xl tw-mx-auto tw-px-4 tw-pb-10">
      <RegisterAccess page={'análise de processo'} />

      <HeaderSession 
      // title={'Gestão de Pedidos de Licenciamento'} 
      title={'ANÁLISE DE PROCESSO'}
      />

      {estabelecimento && observacoesFeitas !== null ? (
        <>
          {/* Alerta: processo reprovado */}
          {estabelecimento?.statusInspeccao === 'Reprovada' && (
            <AlertEdit
              texto={'Este processo foi reprovado porque o estabelecimento mostrou deficiências no acto da inspecção. O estabelecimento está a organizar-se para solicitar uma nova inspecção.'}
            />
          )}

          {/* Informação do estabelecimento após chefe de secção */}
          {estabelecimento?.statusInspeccao &&
            estabelecimento?.statusInspeccao !== 'Reprovada' &&
            estabelecimento.status === 'Analisado Chefe de Secção' && (
              <div className="tw-bg-white tw-rounded-xl tw-border tw-border-gray-100 tw-shadow-sm tw-p-5 tw-mb-4">
                <p className="tw-text-sm tw-text-gray-600 tw-mb-2 tw-font-medium">
                  O estabelecimento informou o seguinte:
                </p>
                <TextoFormatado texto={estabelecimento.statusInspeccao} />
              </div>
            )}

          {/* Layout: nav lateral + conteúdo */}
          <div className="tw-flex tw-gap-5 tw-items-start">

            {/* Nav Lateral (sticky) */}
            <div
              className="tw-w-[290px] tw-flex-shrink-0"
              style={{ position: 'sticky', top: 70 }}
            >
              <NavLateral
                observacoesFeitas={observacoesFeitas}
                estabelecimento={estabelecimento}
              />
            </div>

            {/* Conteúdo principal */}
            <div className="tw-flex-1 tw-min-w-0">
              {React.cloneElement(component, {
                estabelecimento,
                solicitacaoRenovacao,
              })}
            </div>
          </div>
        </>
      ) : (
        <ProcessoLoading />
      )}
    </div>
  );
}
